import { TimeoffLeavesDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { Folder } from 'modules/documents/hooks/useGetFolders'
import { ALL_TYPES } from 'modules/documents/lib/constants'

import InformationLink from './InformationLink'

interface Props {
  employeeId: number
  companyId: number
  legalEntityId: number
  targetId: number
  folders: Folder[]
}

const NewAbsence = ({ employeeId, companyId, legalEntityId, targetId, folders }: Props) => {
  const { navigation } = useNavigation()
  const sickFolders = folders.filter((folder) => folder.url == ALL_TYPES['sick_leave'])
  const sickLeaveFolderId = sickFolders[0]?.id

  const { data, loading } = useQuery(TimeoffLeavesDocument, {
    variables: {
      ids: [targetId],
    },
  })
  const isDeleted = data?.timeoff?.leavesConnection?.nodes?.[0]?.deletedAt !== null

  if (loading) return null

  return (
    <>
      {!isDeleted && (
        <InformationLink
          href={`${navigation.employees.id.timeOff.leavesEditLeaveId.fullPath({
            id: employeeId,
            leave_id: targetId,
          })}?switchToCompanyId=${companyId}`}
          label={i18n.t('bookkeepers.incidence.details.see_absence_detail')}
        />
      )}
      <InformationLink
        href={`${navigation.employees.id.documents.folderId.fullPath({
          id: employeeId,
          folderId: Number(sickLeaveFolderId),
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_medical_leaves_documents')}
      />
      <InformationLink
        href={`${navigation.employees.id.timeOff.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_time_off')}
      />
      <InformationLink
        href={`${navigation.settings.legalEntitiesId.fullPath({
          id: legalEntityId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_legal_entity')}
      />
    </>
  )
}

export default NewAbsence
